import { render, staticRenderFns } from "./riskProcessManage.vue?vue&type=template&id=499c8cfc"
import script from "./riskProcessManage.vue?vue&type=script&lang=js"
export * from "./riskProcessManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('499c8cfc')) {
      api.createRecord('499c8cfc', component.options)
    } else {
      api.reload('499c8cfc', component.options)
    }
    module.hot.accept("./riskProcessManage.vue?vue&type=template&id=499c8cfc", function () {
      api.rerender('499c8cfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/base/riskProcessManage.vue"
export default component.exports